export default __webpack_public_path__ + "static/product-b-press-79d35cc299dc95be3cc1e2f6331835d5.jpg";